'use client';

import { ReactNode, useEffect } from 'react';
import { AnimatedGradientBackground } from '@/components/AnimatedGradientBackground';
import { MentorSearchBackButton } from '@/components/MentorSearchBackButton';
import Section from '@/components/ui/Section';

interface ProfilePageWrapperProps {
  headerContent: ReactNode;
  children: ReactNode;
}

export function ProfilePageWrapper({ headerContent, children }: ProfilePageWrapperProps) {
  // Clear the "came from search" flag if we're navigating from another mentor profile
  useEffect(() => {
    if (typeof window === 'undefined') return;
    
    // Get the current profile handle from URL
    const currentHandle = window.location.pathname.split('/mentors/')[1]?.split('/')[0];
    const lastProfileHandle = sessionStorage.getItem('lastMentorProfileHandle');
    
    // If we're navigating from one profile to a different profile, clear the search flags
    if (lastProfileHandle && lastProfileHandle !== currentHandle) {
      sessionStorage.removeItem('cameFromMentorSearch');
      sessionStorage.removeItem('mentorSearchScrollY');
      sessionStorage.removeItem('mentorSearchUrl');
    }
    
    // Store current profile handle
    if (currentHandle) {
      sessionStorage.setItem('lastMentorProfileHandle', currentHandle);
    }
  }, []);

  return (
    <>
      {/* Animated gradient header */}
      <AnimatedGradientBackground animateOnEnter>
        <div style={{ position: 'relative' }}>
          <MentorSearchBackButton />
          <Section py="sm">
            {headerContent}
          </Section>
        </div>
      </AnimatedGradientBackground>
      
      {/* Main content */}
      {children}
    </>
  );
}
